import React, { useRef, useState } from "react";
import Navbar from "../Components/Navbar";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer";
import axios, { cookies } from "../axios/axios";
import { ToastContainer, toast } from "react-toastify";
import logo from "../images/logo.jpg";
import RecaptchaField, {
  isRecaptchaConfigured,
} from "../Components/RecaptchaField";

const SignUp = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const [captchaToken, setCaptchaToken] = useState("");
  const recaptchaRef = useRef(null);

  const [register, setRegister] = useState({
    fname: "",
    lname: "",
    studio_name: "",
    website_link: "",
    email: "",
    password: "",
    cpassword: "",
    // role: "user",
  });

  const registerHandler = (e) => {
    const { name, value } = e.target;
    setRegister({ ...register, [name]: value });
  };

  const registerSubmit = async (e) => {
    e.preventDefault();
    if (isRecaptchaConfigured && !captchaToken) {
      toast.error("Please complete the captcha.");
      return;
    }
    // console.log(register);
    try {
      const response = await axios.post("/auth/register", {
        ...register,
        captchaToken,
      });
      const data = response.data;
      toast.success("Registered successfully!");

      if (data) {
        cookies.set("user", data, { path: "/" });
        window.location.href = "/";
      }
    } catch (error) {
      console.log(error);
      setErrorMessage(error.response.data.message);
      toast.error(error.response?.data?.message || "An error occurred");
      recaptchaRef.current?.reset();
      setCaptchaToken("");
    }
  };

  // password visibility
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  return (
    <div style={{ minHeight: "100vh" }} className="bg-light">
      <Navbar />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="bg-white col-md-8 mx-auto row px-4 py-5 my-5">
        <h1 className="amaranth-regular fw-bold text-center mb-4">
          {" "}
          <Link to={"/"} className="navbar-brand">
            <img src={logo} width={250} height={150} alt="" />
          </Link>{" "}
        </h1>

        <form onSubmit={registerSubmit}>
          <h4 className="text-center fw-bold prata-regular mb-4">
            New client info
          </h4>

          <div className="row">
            <div className="col-md-6">
              <div class="mb-3">
                <input
                  onChange={registerHandler}
                  name="fname"
                  value={register.fname}
                  type="text"
                  placeholder="First Name *"
                  class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                  id="exampleInputFirstName1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div class="mb-3">
                <input
                  onChange={registerHandler}
                  name="lname"
                  value={register.lname}
                  type="text"
                  placeholder="Last Name *"
                  class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                  id="exampleInputLastName1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
          </div>
          <div class="mb-3">
            <input
              onChange={registerHandler}
              name="email"
              value={register.email}
              type="email"
              placeholder="Email *"
              class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
            />
          </div>
          <div className="row">
            <div className="col-md-6">
              <div class="mb-3">
                <input
                  onChange={registerHandler}
                  name="studio_name"
                  value={register.studio_name}
                  type="text"
                  placeholder="Studio Name *"
                  class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div class="mb-3">
                <input
                  onChange={registerHandler}
                  name="website_link"
                  value={register.website_link}
                  type="text"
                  placeholder="Website *"
                  class="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
                />
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="position-relative d-flex align-items-center">
              <input
                onChange={registerHandler}
                name="password"
                value={register.password}
                type={showPassword ? "text" : "password"}
                placeholder="Password *"
                className="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
              />
              <div
                className="position-absolute top-50 end-0 me-3 translate-middle-y cursor-pointer"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="position-relative d-flex align-items-center">
              <input
                onChange={registerHandler}
                name="cpassword"
                value={register.cpassword}
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password *"
                className="form-control w-full pr-10 shadow-none py-3 flex-grow-1 rounded-2"
              />
              <div
                className="position-absolute top-50 end-0 me-3 translate-middle-y cursor-pointer"
                onClick={toggleConfirmPasswordVisibility}
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
            </div>
          </div>

          <RecaptchaField ref={recaptchaRef} onChange={setCaptchaToken} />

          <button
            type="submit"
            name="submit"
            class="btn bg_maincolor text-light"
          >
            Submit
          </button>
          <div>
            <p className="fs-15 mt-5">
              Already have an account?{" "}
              <Link to={"/login"} className="text-dark">
                Log in
              </Link>{" "}
            </p>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default SignUp;
